var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left_center radio-div",on:{"click":_vm.selfClick}},[_c('span',{staticClass:"iconfont radio",class:{'icon-radio':_vm.isCheck,'icon-RadioButton':!_vm.isCheck},style:('color:'+_vm.color+';')}),_vm._v(" "),_c('span',{staticClass:"radio-label font-65"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c69c560","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhy-radio/xhy-radio.vue
// module id = null
// module chunks = 